import { API, authClient } from '../index';

export const getReport = (threadId) => {
	return authClient().get(`${API}/report/`);
};
